<div class="agpr-formField agpr-textField">
    <div
        *ngIf="field.label"
        class="agpr-formField-label"
    >
        {{ field.label | localize }}
    </div>
    <agpr-dropdown
        [id]="id + '.dropdown'"
        [options]="field.options"
        ariaLabel="Dashboard.manageChart.numberOfTopics"
        [(ngModel)]="seriesCount"
        (ngModelChange)="onDropdownChanged($event.value)"
    ></agpr-dropdown>
</div>
